module.exports = {"pathContext":{"name":"StripeInvoiceSettings","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"defaultPaymentMethod","type":{"kind":"OBJECT","name":"StripePaymentMethod","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-stripe-invoice-settings.json
// module id = 2034
// module chunks = 39359645935544